<app-main-nav></app-main-nav>
<router-outlet></router-outlet>
<app-landing *ngIf="ifLanding"></app-landing>
<app-main-footer *ngIf="!hideFooter"></app-main-footer>